import React from "react";
import DateHelpers from '../Helper/DateHelpers.js';
import { useState } from "react";
import '../Styles/TransactionCard.scss';
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";

function TransactionCard({ transaction }) {
   console.log("Here's Transactions", transaction)
   return (
         <div className='TransactionCardContainer'>
            <div className="TransactionCardContent">
               <div className="TransactionCardDetails">

               <div className="TransactionCardDate">
                     {DateHelpers.getDisplayDate(transaction.transaction_date)}
                  </div>
                  <div className="TransactionCardPaymentAmount">
                     ${transaction.transaction_amount}
                  </div>
                  <div className="TransactionCardPaymentType">
                     Payment Type: {transaction.payment_type}
                  </div>
                  { transaction.check_number != null &&
                          <div className="TransactionCardCheckNumber">
                          Check Number: {transaction.check_number}
                       </div>
                  }
                  { transaction.credit_card_identifier != null &&
                     <div className="TransactionCardCheckNumber">
                          Credit Card : {transaction.credit_card_identifier}
                       </div>
                  }
             

               </div>

            </div>
         </div>
   )
}
export default TransactionCard;